import { render } from "./Infos.vue?vue&type=template&id=9ad31d5a"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"

import "./Infos.vue?vue&type=style&index=0&id=9ad31d5a&lang=less"
script.render = render

export default script